import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.css'
})
export class ModalComponent implements OnInit {

  @Output() close = new EventEmitter<boolean>();

  constructor(private _loaderService: LoaderService) { }

  ngOnInit(): void {
    this._loaderService.hide();
  }

  onClose(){
    this.close.emit(true);
  }

}
